var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js/pure';
import { connect } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import * as actions from '../../store/resellerSelectedManagedOrgDevPlan/actions';
import { makeSelectDevPlanInterval, selectFilteredDevPlans, selectDeveloperPlanStatus, makeSelectActiveDeveloperPlan, makeSelectDevPlans, selectProRatedAmount, selectProRatedAmountLoading, selectProRatedAmountError, } from '../../store/resellerSelectedManagedOrgDevPlan/selectors';
import DevPlanConfirmModal from '../../components/DeveloperPlans/DevPlanConfirmModal';
import DevPlanUpdateModal from '../../components/DeveloperPlans/DevPlanUpdateModal';
import { selectOrganizations } from '../Root/selectors';
import { useErrorToast } from '../../utils/hooks/toast';
import { Helmet } from 'react-helmet';
import { PageContent, PageHeader, PageHeaderTitle, PageWrapper, } from '../../components/Page';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import DevPlanCardWrapper from '../../components/DeveloperPlans/DevPlanCardWrapper';
var OrganizationDeveloperPlans = function (_a) {
    var listDeveloperPlans = _a.listDeveloperPlans, organizations = _a.organizations, purchaseDeveloperPlansOrg = _a.purchaseDeveloperPlansOrg, developerPlans = _a.developerPlans, developerPlans_loading = _a.developerPlans_loading, developerPlanPurchase_error = _a.developerPlanPurchase_error, devPlanStatus = _a.devPlanStatus, getDevPlanStatus = _a.getDevPlanStatus, developerPlanPurchase_loading = _a.developerPlanPurchase_loading, interval = _a.interval, changeInterval = _a.changeInterval, purchasedDeveloperPlan = _a.purchasedDeveloperPlan, activeDeveloperPlan = _a.activeDeveloperPlan, getProRatedAmount = _a.getProRatedAmount, proRatedAmount = _a.proRatedAmount, proRatedAmountLoading = _a.proRatedAmountLoading, proRatedAmountError = _a.proRatedAmountError;
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var params = useParams();
    var _b = params.resellerOrgId, resellerOrgId = _b === void 0 ? '' : _b, _c = params.managedOrgId, managedOrgId = _c === void 0 ? '' : _c;
    var resellerOrg = organizations.find(function (org) { return org.id === resellerOrgId; });
    var managedOrg = organizations.find(function (org) { return org.id === managedOrgId; });
    var _d = useState(false), openDevPlanConfirmModal = _d[0], setOpenDevPlanConfirmModal = _d[1];
    var _e = useState(false), openDevPlanUpdateModal = _e[0], setOpenDevPlanUpdateModal = _e[1];
    var _f = useState(), selectedPlan = _f[0], setSelectedPlan = _f[1];
    var stripeKey = process.env.STRIPE_KEY;
    var stripePromise = loadStripe(stripeKey || '');
    var crumbs = [{ to: '', text: 'Developer Plans' }];
    if (managedOrgId) {
        crumbs = [
            { to: '/partner/resellers', text: 'Resellers' },
            {
                to: "/partner/resellers/".concat(resellerOrgId),
                text: (resellerOrg === null || resellerOrg === void 0 ? void 0 : resellerOrg.name) || 'Loading...',
            },
            {
                to: '',
                text: "".concat((managedOrg === null || managedOrg === void 0 ? void 0 : managedOrg.name) || 'Loading...', ": Developer Plans"),
            },
        ];
    }
    useEffect(function () {
        getDevPlanStatus(resellerOrgId, managedOrgId);
    }, [resellerOrgId, managedOrgId, getDevPlanStatus]);
    useEffect(function () {
        if (managedOrgId) {
            listDeveloperPlans(resellerOrgId, managedOrgId);
        }
    }, [listDeveloperPlans, managedOrgId, resellerOrgId]);
    useEffect(function () {
        (activeDeveloperPlan === null || activeDeveloperPlan === void 0 ? void 0 : activeDeveloperPlan.id) &&
            selectedPlan &&
            getProRatedAmount(resellerOrgId, managedOrgId, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id);
    }, [
        getProRatedAmount,
        selectedPlan,
        resellerOrgId,
        managedOrgId,
        activeDeveloperPlan === null || activeDeveloperPlan === void 0 ? void 0 : activeDeveloperPlan.id,
    ]);
    useErrorToast('An error occurred while purchasing developer plan', [
        !developerPlanPurchase_loading,
        developerPlanPurchase_error,
    ]);
    useErrorToast('An error occurred while calculating proration', [
        !proRatedAmountLoading,
        proRatedAmountError,
    ]);
    var onSubscribeButtonClick = function (plan) {
        setSelectedPlan(plan);
        (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'active' || (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'trialing'
            ? setOpenDevPlanUpdateModal(true)
            : setOpenDevPlanConfirmModal(true);
    };
    var onSubscribe = function (update) { return __awaiter(void 0, void 0, void 0, function () {
        var purchase;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    update
                        ? setOpenDevPlanUpdateModal(false)
                        : setOpenDevPlanConfirmModal(false);
                    return [4 /*yield*/, purchaseDeveloperPlansOrg(resellerOrgId, managedOrgId, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id, [])];
                case 1:
                    purchase = _a.sent();
                    purchase && navigate(pathname.replace('/available', '/usage'));
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(DevPlanConfirmModal, { isVisible: openDevPlanConfirmModal, setIsVisible: setOpenDevPlanConfirmModal, primaryButtonAction: onSubscribe, selectedPlan: selectedPlan }), _jsx(DevPlanUpdateModal, { isVisible: openDevPlanUpdateModal, setIsVisible: setOpenDevPlanUpdateModal, primaryButtonAction: onSubscribe, selectedPlan: selectedPlan, activeDeveloperPlan: activeDeveloperPlan, proRatedAmountLoading: proRatedAmountLoading, proRatedAmount: proRatedAmount.managedOrgId === managedOrgId &&
                    proRatedAmount.devPlanId === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id)
                    ? proRatedAmount
                    : {} }), _jsxs(PageWrapper, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Developer Plans" }) }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsx(PageContent, { children: _jsx(DevPlanCardWrapper, { purchasedDeveloperPlan: purchasedDeveloperPlan, changeInterval: changeInterval, stripePromise: stripePromise, onSubscribeButtonClick: onSubscribeButtonClick, developerPlanPurchase_loading: developerPlanPurchase_loading, devPlanStatus: devPlanStatus, developerPlans: developerPlans === null || developerPlans === void 0 ? void 0 : developerPlans.filter(function (devPlan) { return (devPlan === null || devPlan === void 0 ? void 0 : devPlan.interval) === interval; }), developerPlans_loading: developerPlans_loading, interval: interval }) })] })] }));
};
var mapStateToProps = function (state) { return (__assign({ developerPlans: selectFilteredDevPlans(state), interval: makeSelectDevPlanInterval(state), devPlanStatus: selectDeveloperPlanStatus(state), organizations: selectOrganizations(state), activeDeveloperPlan: makeSelectActiveDeveloperPlan(state), proRatedAmount: selectProRatedAmount(state), proRatedAmountLoading: selectProRatedAmountLoading(state), proRatedAmountError: selectProRatedAmountError(state) }, makeSelectDevPlans(state))); };
var mapDispatchToProps = function (dispatch) { return ({
    listDeveloperPlans: function (resellerOrgId, managedOrgId) {
        dispatch(actions.getManageDevPlanByResellerId(resellerOrgId, managedOrgId));
    },
    changeInterval: function (interval) {
        dispatch(actions.changeInterval(interval));
    },
    getDevPlanStatus: function (resellerOrgId, managedOrgId) {
        dispatch(actions.getManagedOrgDevPlanStatus(resellerOrgId, managedOrgId));
    },
    purchaseDeveloperPlansOrg: function (resellerOrgId, managedOrgId, DevPlanId, Bundles) {
        return dispatch(actions.purchaseDeveloperPlansOrg(resellerOrgId, managedOrgId, DevPlanId, Bundles));
    },
    getProRatedAmount: function (resellerOrgId, managedOrgId, devPlanId) {
        dispatch(actions.getProRatedAmount(resellerOrgId, managedOrgId, devPlanId));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(OrganizationDeveloperPlans);
